import React, { useCallback } from 'react'

import {
  BottomTabNavigationOptions,
  createBottomTabNavigator,
} from '@react-navigation/bottom-tabs'
import { ParamListBase, RouteProp } from '@react-navigation/native'
import { Categories } from '@zet/feature-brands/screens/categories'
import { Leads } from '@zet/feature-leads/screens/leads'

import HomeScreenHeader from '../../components/homeScreenHeader'
import { i18n } from '../../localization'
import HomeScreen from '../../screens/homeScreen'
import BottomTabLayout from './BottomTabLayout'

const PrivateScreenTab = createBottomTabNavigator()

const BottomTabNavigation = () => {
  const locale = i18n.locale
  const screenOptions:
    | BottomTabNavigationOptions
    | ((props: {
        route: RouteProp<ParamListBase, string>
        navigation: any
      }) => BottomTabNavigationOptions) = useCallback(
    ({ route }: { route: { name: string } }) => ({
      tabBarShowLabel: false,
      tabBarStyle: {
        height: 50,
        paddingTop: 6,
      },
      tabBarIcon: ({ focused }: { focused: boolean }) => {
        let iconName
        switch (route.name) {
          case 'HomeScreen':
            iconName = focused ? 'HomeFilled' : 'HomeOutlined'
            return (
              <BottomTabLayout
                focused={focused}
                label={i18n.t('botomTab.home')}
                icon={iconName}
              />
            )
          case 'Products':
            iconName = focused ? 'MoreFilled' : 'MoreOutlined'
            return (
              <BottomTabLayout
                focused={focused}
                label={i18n.t('botomTab.products')}
                icon={iconName}
              />
            )
          case 'Leads':
            iconName = focused ? 'AssignedFilled' : 'AssignedOutlined'
            return (
              <BottomTabLayout
                focused={focused}
                label={i18n.t('botomTab.leads')}
                icon={iconName}
              />
            )
        }
      },
    }),
    [locale]
  )
  return (
    <PrivateScreenTab.Navigator
      initialRouteName="HomeScreen"
      screenOptions={screenOptions}
    >
      <PrivateScreenTab.Group>
        <PrivateScreenTab.Screen
          name="HomeScreen"
          component={HomeScreen}
          options={{
            header: () => <HomeScreenHeader />,
          }}
        />
        <PrivateScreenTab.Screen
          options={{ headerShown: false }}
          name="Products"
          component={Categories}
        />
        <PrivateScreenTab.Screen
          options={{ headerShown: false }}
          name="Leads"
          component={Leads}
        />
      </PrivateScreenTab.Group>
    </PrivateScreenTab.Navigator>
  )
}

export default BottomTabNavigation
